/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const ChevronUpOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m4.5 15.75 7.5-7.5 7.5 7.5"
})));
// Fill
const ChevronUpFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m20.03 15.218-7.5-7.5a.745.745 0 0 0-1.06 0l-7.5 7.5a.673.673 0 0 0-.2.389.725.725 0 0 0 .04.436c.05.136.15.253.27.334.13.082.27.125.42.125h15c.15 0 .29-.043.42-.125a.707.707 0 0 0 .27-.334c.06-.139.07-.29.04-.436s-.09-.281-.2-.389z"
})));
// DuoTone
const ChevronUpDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m4.5 15.75 7.5-7.5 7.5 7.5h-15z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m4.5 15.75 7.5-7.5 7.5 7.5h-15z"
})));
/**
  Icon ChevronUpIcon in arrows group
*/
export const ChevronUpIcon = createIcon('ChevronUpIcon', 'chevron-up', 'arrows', ChevronUpOutline, ChevronUpFill, ChevronUpDuotone, "0 0 24 24");